import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, ShieldCheck, Users, BookOpen, Star, MapPin } from 'lucide-react';
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative flex flex-col w-full" data-id="element-129">
      {/* Hero Area */}
      <div className="relative bg-gradient-to-br from-deep to-agua pt-8 pb-14 sm:pt-12 sm:pb-20 px-4 sm:px-6 lg:px-8 overflow-hidden" data-id="element-130">
        <div className="max-w-6xl mx-auto flex flex-col items-center relative z-10" data-id="element-131">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="flex flex-col items-center text-center space-y-3 sm:space-y-5" data-id="element-132">
            <div className="inline-flex items-center bg-turquoise/20 border border-turquoise/30 text-turquoise px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider w-fit" data-id="element-133">
              Sistema N°1 para Profes de Natación en Argentina
            </div>

            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black text-white tracking-tight text-[32px]" data-id="element-134">
              TODO TU AÑO DE NATACIÓN{' '}
              <span className="text-turquoise" data-id="element-135">RESUELTO</span>
            </h1>

            {/* Mockup Image at 80% */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} className="relative flex justify-center w-[65%] sm:w-[80%] my-2 sm:my-4" data-id="element-136">
              <div className="relative w-full" data-id="element-137">
                <div className="absolute inset-0 bg-turquoise/20 blur-3xl rounded-full transform scale-90" data-id="element-138"></div>
                <img src="https://cdn.magicpatterns.com/uploads/hrKQndEUB8kmfBthUXjtga/heylloyd-image-1777167115383-Photoroom.png" alt="Profe de Natación Resuelto Megapack" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-139" />
              </div>
            </motion.div>

            <p className="sm:text-lg text-white/90 max-w-xl text-[14px]" data-id="element-140">
              Tu año completo de clases de natación listo: fundamentos, técnica
              de los 4 estilos, planificación por niveles, grupos especiales,
              preparación física, liderazgo y mucho más. Sin improvisar nunca
              más al borde de la pileta.
            </p>

            <ul className="grid grid-cols-2 gap-2 text-white/90 text-sm sm:text-base font-medium mt-2" data-id="element-141">
              <li className="flex items-center gap-2" data-id="element-142">
                <CheckCircle2 className="w-5 h-5 text-turquoise" data-id="element-143" /> PDF digital
              </li>
              <li className="flex items-center gap-2" data-id="element-144">
                <CheckCircle2 className="w-5 h-5 text-turquoise" data-id="element-145" /> Acceso
                inmediato
              </li>
              <li className="flex items-center gap-2" data-id="element-146">
                <CheckCircle2 className="w-5 h-5 text-turquoise" data-id="element-147" /> Todos los
                niveles
              </li>
              <li className="flex items-center gap-2" data-id="element-148">
                <CheckCircle2 className="w-5 h-5 text-turquoise" data-id="element-149" /> Garantía 7
                días
              </li>
            </ul>

            <div className="pt-2 sm:pt-4 flex flex-col items-center gap-3" data-id="element-150">
              <button onClick={scrollToPricing} className="w-full sm:w-auto bg-agua hover:bg-agua-dark text-white font-black text-lg sm:text-xl py-4 px-8 rounded-xl shadow-[0_8px_20px_rgba(0,180,216,0.4)] hover:shadow-[0_10px_25px_rgba(0,180,216,0.6)] transition-all transform hover:-translate-y-1 flex items-center justify-center gap-2" data-id="element-151">
                <span data-id="element-152">💥 QUIERO MI PROFE DE NATACIÓN RESUELTO</span>
              </button>
              <div className="flex items-center gap-2 text-white/80 text-xs sm:text-sm font-medium" data-id="element-153">
                <ShieldCheck className="w-4 h-4 text-turquoise" data-id="element-154" />
                Pago 100% seguro · Mercado Pago | Tarjeta | Transferencia
              </div>
            </div>
          </motion.div>
        </div>

        {/* Decorative Wave Bottom */}
        <div className="absolute bottom-0 left-0 right-0 w-full overflow-hidden leading-none z-0" data-id="element-155">
          <svg className="relative block w-full h-[40px] sm:h-[60px]" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none" data-id="element-156">
            <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V120H0V95.8C59.71,118.08,130.83,121.32,201.5,114.2,242.15,110.11,282.49,94.13,321.39,56.44Z" fill="#ffffff" data-id="element-157"></path>
          </svg>
        </div>
      </div>

      {/* Trust Badges */}
      <div className="bg-white px-4 py-3 sm:py-6 relative z-20 -mt-8 sm:-mt-12 max-w-6xl mx-auto w-full" data-id="element-158">
        <div className="bg-white rounded-2xl shadow-lg border border-agua/20 p-2 sm:p-4 grid grid-cols-2 md:grid-cols-4 gap-2 sm:gap-4 divide-x-0 md:divide-x divide-y md:divide-y-0 divide-gray-100" data-id="element-159">
          <div className="flex flex-col items-center justify-center text-center p-2" data-id="element-160">
            <Users className="w-6 h-6 text-agua mb-1" data-id="element-161" />
            <span className="text-sm font-bold text-deep" data-id="element-162">
              +500 profes confían
            </span>
          </div>
          <div className="flex flex-col items-center justify-center text-center p-2" data-id="element-163">
            <BookOpen className="w-6 h-6 text-agua mb-1" data-id="element-164" />
            <span className="text-sm font-bold text-deep" data-id="element-165">
              6 Tomos + 6 Bonos
            </span>
          </div>
          <div className="flex flex-col items-center justify-center text-center p-2" data-id="element-166">
            <Star className="w-6 h-6 text-agua mb-1 fill-agua" data-id="element-167" />
            <span className="text-sm font-bold text-deep" data-id="element-168">
              4.9/5 valoración
            </span>
          </div>
          <div className="flex flex-col items-center justify-center text-center p-2" data-id="element-169">
            <MapPin className="w-6 h-6 text-agua mb-1" data-id="element-170" />
            <span className="text-sm font-bold text-deep" data-id="element-171">🇦🇷 Todo el país</span>
          </div>
        </div>
      </div>

      {/* Initial Testimonials */}
      <div className="bg-white px-4 py-4 sm:py-12 max-w-6xl mx-auto w-full" data-id="element-172">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3 sm:gap-6" data-id="element-173">
          <TestimonialCard initials="MP" name="Martín P." role="Buenos Aires — PROFE DE NATACIÓN EN NATATORIO" text="Organicé todo mi año de clases de natación en una tarde. Tengo cada clase pensada y secuenciada para todos mis grupos. Nunca más el domingo de pánico antes de la semana." data-id="element-174" />
          <TestimonialCard initials="LG" name="Laura G." role="Rosario — PROFE DE NATACIÓN EN CLUB DEPORTIVO" text="Las progresiones por nivel cambiaron todo. Mis alumnos avanzaron más en 2 meses que en todo el año anterior. Y dejaron de abandonar antes de tiempo." data-id="element-175" />
          <TestimonialCard initials="DR" name="Diego R." role="Córdoba — PROFE DE NATACIÓN GRUPAL E INDIVIDUAL" text="Adapto el mismo ejercicio a 3 niveles distintos en 5 minutos. Antes me llevaba horas pensar qué hacer con un grupo mezclado de principiantes y avanzados." data-id="element-176" />
        </div>
      </div>
    </section>;
}
function TestimonialCard({
  initials,
  name,
  role,
  text
}: {
  initials: string;
  name: string;
  role: string;
  text: string;
}) {
  return <motion.div whileHover={{
    y: -5,
    boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)'
  }} className="bg-white p-3 sm:p-5 rounded-xl border-l-4 border-l-agua shadow-sm border border-gray-100 flex flex-col h-full transition-all duration-300" data-id="element-177">
      <p className="text-gray-600 text-sm italic mb-4 flex-grow" data-id="element-178">"{text}"</p>
      <div className="flex items-center gap-3 mt-auto pt-3 border-t border-gray-50" data-id="element-179">
        <div className="w-10 h-10 rounded-full bg-light flex items-center justify-center text-deep font-bold text-sm border border-agua/30 shrink-0" data-id="element-180">
          {initials}
        </div>
        <div data-id="element-181">
          <p className="text-deep font-bold text-sm" data-id="element-182">{name}</p>
          <p className="text-xs text-gray-500 line-clamp-1" title={role} data-id="element-183">
            {role}
          </p>
        </div>
      </div>
    </motion.div>;
}